import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function ConvenientLocation() {
  return (
    <section
      id="location"
      aria-labelledby="location-heading"
      className="bg-secondary/40 py-16 md:py-20"
    >
      <div className="shell grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
        <Reveal className="lg:col-span-6" y={36}>
          <img
            src={images.heroSlider}
            alt="Historic Auburn California near Auburn RV Resort"
            width={1400}
            height={1200}
            loading="lazy"
            decoding="async"
            className="aspect-[5/4] w-full object-cover"
          />
        </Reveal>

        <div className="lg:col-span-6">
          <Reveal>
            <Eyebrow>Close to What You Need</Eyebrow>
          </Reveal>
          <h2 id="location-heading" className="display-lg mt-6 max-w-[12ch]">
            <MaskReveal>Easy Access</MaskReveal>
            <MaskReveal delay={0.08}>to Auburn</MaskReveal>
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-muted-foreground">
              Auburn RV Resort is conveniently located a short drive from shopping, services and
              local businesses, making it easy to pick up supplies or take care of everyday needs
              during your stay.
            </p>
          </Reveal>
          <Reveal delay={0.16}>
            <ResortLink
              variant="solid"
              href="/nearby-attractions/"
              className="mt-10 w-full sm:w-auto"
            >
              Explore Auburn
            </ResortLink>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
